export enum AccessPointsTab {
  BSSIDs = 'bssids',
  Current = 'list',
  Insights = 'insights',
  Spares = 'spares',
  ACS = 'acs',
  ConfigHistory = 'config-history',
  Neighbors = 'neighbors',
}

export enum AccessPointTab {
  BSSIDs = 'bssids',
  BootHistory = 'boot-history',
  Clients = 'clients',
  ConfigHistory = 'config-history',
  ConnectionEvents = 'connection-events',
  Insights = 'insights',
  Neighbors = 'neighbors',
}

export enum AccessPointDrawerTab {
  AccessPoint = 'access-point',
  Clients = 'clients',
  Edit = 'edit',
}

export enum AccessPointEditTab {
  Config = 'config',
  Hardware = 'hardware',
}

export const AccessPointNeighborsTooltip =
  'Uses meter devices to scan the surrounding wireless environment and identify nearby networks.';
